import React, { FC } from "react";
import NavItemParent from "Components/Navigation/SideNav/NavItem/NavItemParent/NavItemParent";
import NavItemSingle from "Components/Navigation/SideNav/NavItem/NavItemSingle/NavItemSingle";
import { INavItemSingle, INavItemParent } from "Shared/types/NavItems";

export type NavItemProps = INavItemSingle | INavItemParent;

const NavItem: FC<NavItemProps> = props => {
  return props.kind === "parent" ? (
    <NavItemParent {...props} />
  ) : (
    <NavItemSingle {...props} />
  );
};

export default NavItem;
